import parseUserAgent from 'ua-parser-js';

import { stripNonAscii } from './stringUtils';

export const getReleaseIdentifier = () =>
  stripNonAscii(`${process.env.REACT_APP_BUILD_BRANCH}_${process.env.REACT_APP_BUILD_COMMIT_SHORT}`).toLowerCase();

export const parsedUserAgent = parseUserAgent(navigator.userAgent);

export const isDesktopApp = /Electron/.test(navigator.userAgent);

export const getDeviceInfoHeaders = () =>
  ({
    'App-Version': getReleaseIdentifier(),
    'Device-Name': stripNonAscii(`${parsedUserAgent.browser.name} (${parsedUserAgent.browser.major})`),
    'Device-Type': isDesktopApp ? 'desktop' : 'web',
  }) as Readonly<{
    'App-Version': string;
    'Device-Name': string;
    'Device-Type': string;
  }>;

export const isMobileDevice = (): boolean =>
  /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(globalThis.navigator?.userAgent);

export const isIE = (): boolean => /msie\s|trident\//i.test(globalThis.navigator?.userAgent);
